import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=36092455&scoped=true"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"
import style0 from "./newslist.vue?vue&type=style&index=0&id=36092455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36092455",
  null
  
)

export default component.exports